<template>
    <div class="event-filters">
        <FilterDateSelect />

        <FilterCitySelect />
    </div>
</template>

<script setup lang="ts">
import type { FilterSettingsQuery as FilterSettingsQueryType } from '~/types/craft-schema';
import FilterSettingsQuery from '~/graphql/queries/FilterSettings.graphql';

const { data } = await useLazyAsyncQuery<FilterSettingsQueryType>({
    query: FilterSettingsQuery,
});

const { mainProgramEntry } = storeToRefs(useEventFiltersStore());

watchEffect(() => {
    if (data.value?.globalSet?.mainProgramEntry?.length > 0) {
        mainProgramEntry.value = data.value?.globalSet?.mainProgramEntry;
    }
});
</script>

<style lang="less" src="./EventFilters.less"></style>
